import React, { FC } from 'react';
import { Form, Select } from 'antd';
import { SelectOption } from '../../../AnnotationManager/Annotation/annotation.types';

const { Option } = Select;

type Props = {
  label: string;
  value: string | undefined;
  values: SelectOption[];
  maxWidth?: string;
  dropdownMatchSelectWidth?: boolean;
  onChange: (value: string) => void;
};

export const SearchItem: FC<Props> = ({ label, value, values, maxWidth, dropdownMatchSelectWidth, onChange }) => {
  return (
    <Form.Item label={label} colon={false}>
      <Select
        value={value}
        showSearch
        style={{ minWidth: '150px', maxWidth: maxWidth ? maxWidth : '200px' }}
        allowClear={true}
        placeholder='Please select'
        optionFilterProp='children'
        onChange={onChange}
        dropdownMatchSelectWidth={false}
      >
        {values.map(option => (
          <Option key={option.value} value={option.value}>
            {option.text}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default SearchItem;
